<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="usersListings">
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex style="min-height: 100px" pa-0 v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-flex v-if="options.layout === 'grid'" :class="dataState === 'ready' ? 'secondary' : ''">
          <v-layout row wrap pb-2>
            <v-flex class="item d-block" v-for="(item, index) in users" :key="index" style="cursor: pointer; width: 19.5%; flex: none !important; margin: 2px 0.2%;min-height:350px">
              <v-card class="ma-1 pa-2" style="width:100%;height:100%;" hover :style="'background-color: ' + (Number(item._tweet_count) >= 20 ? '#f5b7b1 ' : '#FFFFFF')">
              {{item._tweet_count}}
                <v-progress-circular
                v-if="options.sortBy !== '_created_at'"
                :value="item[options.sortBy] / topUser * 100"
                :rotate="-90"
                :color="options.sortIcon.color"
                size="70">
                  <v-tooltip top>
                    <v-avatar slot="activator" class="elevation-4" @click="goToUser(item._screen_name)">
                      <img :id="index" :src="item._profile_image_url_https" @error="alternateImg(index)">
                    </v-avatar>
                    <p class="left ma-0 pa-0">Friends:</p><p class="right ma-0 pa-0">{{formatNumber(item._friends_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Likes:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._favourites_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Tweets:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._statuses_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Joined:&nbsp;</p> <p class="ma-0 pa-0 right">{{formatDate(getLocalDate(item._created_at))}}</p>
                  </v-tooltip>
                </v-progress-circular>
                <v-tooltip top v-else>
                  <v-avatar slot="activator" size="70" style="border-top-left-radius:50%;border-top-right-radius:50%;" class="elevation-4 ma-2" @click="goToUser(item._screen_name)">
                    <img :id="index" :src="item._profile_image_url_https.replace('normal', 'bigger')" @error="alternateImg(index)">
                  </v-avatar>
                  <p class="left ma-0 pa-0">Friends:</p><p class="right ma-0 pa-0">{{formatNumber(item._friends_count)}}</p>
                  <p style="clear:both" class="left ma-0 pa-0">Likes:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._favourites_count)}}</p>
                  <p style="clear:both" class="left ma-0 pa-0">Tweets:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._statuses_count)}}</p>
                  <p style="clear:both" class="left ma-0 pa-0">Joined:&nbsp;</p> <p class="ma-0 pa-0 right">{{formatDate(getLocalDate(item._created_at))}}</p>
                </v-tooltip>
                <v-card flat tile style="background-color: transparent;min-height: 40px;">
                  <p class='ma-0 font-weight-medium' style="hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item._name}}
                    <svg v-if="item._verified" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="htc-icon htc-icon--verified"> 
                      <path style="fill: #1DA1F2" opacity="0" d="M0 0h24v24H0z"></path> 
                      <path style="fill: #1DA1F2" d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5c-1.51 0-2.816.917-3.437 2.25-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z"></path> 
                    </svg>
                  </p>
                  <p class='ma-0 font-weight-light' color="gray" style="hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">@{{item._screen_name}}</p>
                  <p class="body-1 my-3">
                    <v-icon small pa-2 color="gray lighten-2">fas fa-users</v-icon>  {{formatNumber(item._followers_count)}}
                    <span v-if="options.sortBy !== '_followers_count' && options.sortBy !== '_created_at'"> &nbsp; 
                      <v-icon :color="options.sortIcon.color" small pa-2>
                        {{options.sortIcon.icon}}
                      </v-icon>
                      {{formatNumber(item[options.sortBy])}}
                    </span>
                    <span v-else-if="options.sortBy === '_created_at'"> &nbsp; 
                      <v-icon :color="options.sortIcon.color" small pa-2>
                        {{options.sortIcon.icon}}
                      </v-icon>  
                      {{formatDate(getLocalDate(item[options.sortBy]))}}
                    </span>
                    <br/>
                    <span>
                      <v-btn-toggle dense flat mandatory v-model="item._activity_type" style="margin-top: 5px;">
                        <v-btn flat @click.stop="updateUserActivityType(item._id, 0)">No Class</v-btn>
                        <v-btn flat @click.stop="updateUserActivityType(item._id, 1)">Real</v-btn>
                        <v-btn flat @click.stop="updateUserActivityType(item._id, 2)">Troll</v-btn>
                        <v-btn flat @click.stop="updateUserActivityType(item._id, 3)">Bot</v-btn>
                      </v-btn-toggle>
                    </span>
                  </p>
                  <p class='caption xs-1' style='overflow: hidden;text-overflow:ellipsis;'>{{ item._description }}</p>
                </v-card>
                <v-flex class="mt-3 pa-0" style="position: absolute; bottom: 10px; justify-content: center;align-items:center;display:flex;width:100%">
                  <v-tooltip top>
                    <v-avatar size="40" slot="activator" @click.stop="goToUser(item._screen_name)">
                      <v-icon class="btnHoverClass" color="blue lighten-2" style="border-radius: 100%">fab fa-twitter</v-icon>
                    </v-avatar>
                    <span>Go to user profile</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-avatar size="40" slot="activator" @click.stop="filterByUser(item._screen_name)">
                      <v-icon class="btnHoverClass" style="border-radius: 100%">filter_list</v-icon>
                    </v-avatar>
                    <span>Filter by user</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-avatar size="40" slot="activator" @click.stop="selectedUser = item._id; deleteUserConfirmationDialog = true">
                      <v-icon class="btnHoverClass" style="border-radius: 100%">fas fa-trash</v-icon>
                    </v-avatar>
                    <span>Delete user</span>
                  </v-tooltip>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-list three-line class="pt-0" v-if="options.layout === 'tiles'" id="usersListingsTiles">
          <v-divider v-if="dataState === 'ready'"></v-divider>
          <v-list-group v-for="(item, index) in users" v-model="item._active" :key="index" append-icon="" no-action>
            <v-list-tile
              slot="activator"
              :key="item._screen_name"
              avatar
              style="max-width: 100%"
              class='pa-0 afterHeader usersListingUserTile'
              :style='index % 2 === 0 ? "background-color: #EFEFEF99" : "background-color: #FFFFFF99"'
              @click.stop="goToUser(item._screen_name)">
              <v-flex style="width: 30%">
                <v-layout row style="flex: none; width: 100%">
                  <v-list-tile-avatar color="grey" style="margin-top: auto; margin-bottom: auto">
                    <img :id="index" v-if="item._profile_image_url_https" :src="item._profile_image_url_https" @error="alternateImg(index)">
                    <v-icon v-else dark>block</v-icon>
                  </v-list-tile-avatar>
                  <v-tooltip top style="width: calc(100% - 60px);">
                    <v-list-tile-content slot="activator" class='pr-4 users'>
                      <v-list-tile-title class="pointer">{{item._name}}
                        <svg v-if="item._verified" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="htc-icon htc-icon--verified"> 
                          <path style="fill: #1DA1F2" opacity="0" d="M0 0h24v24H0z"></path> 
                          <path style="fill: #1DA1F2" d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5c-1.51 0-2.816.917-3.437 2.25-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z"></path> 
                        </svg>
                        <span class="font-weight-light">
                          @{{item._screen_name}}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title style="max-height: 60px" v-if="item._description" class="pointer">
                        {{ item._description.length > 140 ? item._description.slice(0,140) + '...' : item._description }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <p class="left ma-0 pa-0">Friends:</p><p class="right ma-0 pa-0">{{formatNumber(item._friends_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Likes:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._favourites_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Tweets:</p><p class="right ma-0 pa-0 ">{{formatNumber(item._statuses_count)}}</p>
                    <p style="clear:both" class="left ma-0 pa-0">Joined:&nbsp;</p> <p class="ma-0 pa-0 right">{{formatDate(getLocalDate(item._created_at))}}</p>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_tweet_count' ? 'background-color: #64b5f611' : ''">
              <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-3">fab fa-twitter</v-icon><p>{{ formatNumber(item._tweet_count) }}</p></v-list-tile-title>
            </v-list-tile-content>
              <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_followers_count' ? 'background-color: #AAAAAA11' : ''">
              <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="gray lighten-2">fas fa-users</v-icon><p>{{ formatNumber(item._followers_count) }}</p></v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_retweet_count' ? 'background-color: #00FF0011' : ''">
              <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="green lighten-2">fas fa-retweet</v-icon><p>{{ formatNumber(item._retweet_count) }}</p></v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_reply_count' ? 'background-color: #0000FF11' : ''">
              <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fas fa-comment</v-icon><p>{{ formatNumber(item._reply_count) }}</p></v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_quote_count' ? 'background-color: #00FFFF11' : ''">
              <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="teal lighten-2">fas fa-quote-right</v-icon><p>{{ formatNumber(item._quote_count) }}</p></v-list-tile-title>
            </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters align-center' :style="options.sortBy === '_created_at' ? 'background-color: #FFB74D11' : ''">
                <v-layout row class="align-center justify-content-center">
                  <v-flex sm2>
                    <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                  </v-flex>
                  <v-flex>
                    <v-list-tile-title>{{ formatDate(getLocalDate(item._created_at)) }}</v-list-tile-title>
                    <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._created_at))"></v-list-tile-sub-title>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' style="display: flex; align-items: center; justify-content: center" @click.stop="getTweets(index, false)">
                <v-list-tile-content><v-btn small class="ma-0 px-2" color="blue white--text">View Tweets</v-btn></v-list-tile-content>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class="actions align-center">
                <v-list-tile-avatar @click.stop="selectedUser = item._id; deleteUserConfirmationDialog = true" color="secondary" size="40" class="pointer" style="margin-top:0; display: flex !important; justify-content: center !important;">
                  <v-btn icon>
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile three-line v-for="(item, index1) in tweets" :key="index1" @click="goToTweet(item._twitter_id, item._user_screen_name)" class="userListingTweetList">
              <v-list-tile-content
                :key="item._id"
                avatar
                style="width: 100%"
                class='px-1'
                :style='innerListStyle(index, index1)'>
                <v-layout row style="width: 100%">
                  <v-list-tile-content class='tweets' style="width:35%">
                    <v-list-tile-sub-title class="pointer tweetText">{{ item._text }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters' :style="options.sortBy === '_tweet_count' || options.sortBy === '_followers_count' ? 'background-color: #AAAAAA11' : ''">
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="gray lighten-2">fas fa-users</v-icon><p>{{ formatNumber(item._user_followers_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters' :style="options.sortBy === '_retweet_count' ? 'background-color: #00FF0011' : ''">
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="green lighten-2">fas fa-retweet</v-icon><p>{{ formatNumber(item._retweet_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters' :style="options.sortBy === '_favorite_count' ? 'background-color: #FF000011' : ''">
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="red lighten-2">fas fa-heart</v-icon><p>{{ formatNumber(item._favorite_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters' :style="options.sortBy === '_reply_count' ? 'background-color: #0000FF11' : ''">
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fas fa-comment</v-icon><p>{{ formatNumber(item._reply_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters' :style="options.sortBy === '_quote_count' ? 'background-color: #00FFFF11' : ''">
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="teal lighten-2">fas fa-quote-right</v-icon><p>{{ formatNumber(item._quote_count) }}</p></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters align-center' :style="options.sortBy === '_created_at' ? 'background-color: #FFB74D11' : ''" style="width: 15%">
                    <v-layout row class="align-center justify-content-center">
                      <v-flex sm2>
                        <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                      </v-flex>
                      <v-flex>
                        <v-list-tile-title>{{ formatDate(getLocalDate(item._created_at)) }}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._created_at))"></v-list-tile-sub-title>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                  <v-list-tile-content class='tweetCounters'>
                    <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="teal lighten-2" @click.stop="selectedTweet = item._tweet_id; deleteTweetConfirmationDialog = true">fas fa-trash</v-icon></v-list-tile-title>
                  </v-list-tile-content>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="userListingTweetList" v-if="tweets.length !== item._tweet_count && dataTweetsState === 'ready'">
              <v-list-tile-content style="width: 100%" class="align-center"><v-btn outline @click.stop="getMoreTweets(index, item._tweet_count)" class="ma-0 px-2" color="blue white--text">View More</v-btn></v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="dataTweetsState === 'loading'">
              <v-list-tile-content style="width: 100%" class="align-center">
                <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate></v-progress-circular>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else-if="dataTweetsState === 'error'">
              <div style="display: flex; align-items: center; width: 100%; flex-direction: column"><v-icon style="font-size: 40px !important" class="error--text">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <v-dialog
      v-model="deleteUserConfirmationDialog"
      width="300">
      <v-card class="secondary">
        <v-card-title class="headline">Delete user?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteUser" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteUserConfirmationDialog = false; selectedUser = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteTweetConfirmationDialog"
      width="300">
      <v-card class="secondary">
        <v-card-title class="headline">Delete tweet?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteTweet" :loading="deleteTweetLoading">Confirm</v-btn>
          <v-btn @click="deleteTweetConfirmationDialog = false; selectedTweet = null" :disabled="deleteTweetLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  .userListingTweetList .v-list__tile{
    padding-left:0px;
  }
  #usersListings .v-list__tile{
    padding: 0 !important;
  }
  #usersListings .v-btn:focus:before{
    background-color: white !important;
  }
  #usersListings .v-btn--disabled{
    background-color: #e0e0e0 !important;
    border: 1px solid #727272;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  #usersListings .v-btn--disabled:focus:before{
    background-color: #e0e0e0 !important;
  }
  #usersListings .v-btn--disabled i{
    color: #727272 !important;
  }
  #usersListingsTiles div{
    flex: none;
  }
  #usersListingsTiles .afterHeader{
    width: 100%
  }
</style>

<style scoped>
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .counters{
    flex: none;
    width: 9%;
  }
  .actions{
    width: 6%;
    display: flex;
    justify-content: center;
  }
  .btnHoverClass:hover{background-color: #E0E0E0}
  .tweetText{ white-space: normal; max-height: 80px; padding-left: 5%;padding-right: 5%;word-break: break-word;}
  .avatar{ margin-top: auto; margin-bottom: auto }
  .pointer{ cursor: pointer; }
  .users{ width: 100%; padding-right: 5px}
  .htc-icon {
    width: 1em;
    height: 1em;
    position: relative;
    top: 1px;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  .pointer{ 
    cursor: pointer;
  }
  .tweetCounters{ margin: auto 0px; width: 8%;}
  .tweets{ width: 290px; margin: auto 0; }
  .v-list__group.v-list__group--active:before, .v-list__group.v-list__group--active:after{
    left: 0;
  }
  .v-list__group__header.v-list__group__header--active .afterHeader:after{
    content: "";
    height: 1px;
    position: absolute;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1); 
    transition: .3s cubic-bezier(.25,.8,.5,1); 
    width: 100%;
    left: 0;
    background-color: #ededed;
  }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
</style>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import { formatTime, formatDate, getLocalDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      dataTweetsState: 'loading',
      users: [],
      page: 1,
      lastPage: false,
      topUser: 0,
      tweets: [],
      deleteUserConfirmationDialog: false,
      selectedUser: null,
      deleteLoading: false,
      deleteTweetConfirmationDialog: false,
      selectedTweet: null,
      deleteTweetLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    formatDate: formatDate,
    formatTime: formatTime,
    getLocalDate: getLocalDate,
    updateUserActivityType (userId, activityType) {
      axios.all([
        this.$store.dispatch('updateUserActivityType', {userId: userId, activityType: activityType, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.notify({message: 'User successfully updated.', show: true})
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteUser () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteUserById', {id: this.selectedUser, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedUser = null
          this.deleteUserConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteTweet () {
      console.log(this.selectedTweet)
      this.deleteTweetLoading = true
      axios.all([
        this.$store.dispatch('deleteTweetById', {id: this.selectedTweet, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedTweet = null
          this.deleteTweetConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteTweetLoading = false
      })).catch((err) => {
        this.deleteTweetLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    innerListStyle: function (userIndex, tweetIndex) {
      if (userIndex % 2 === 0) {
        if (tweetIndex % 2 === 0) {
          return 'background-color: #FFFFFF99'
        } else {
          return 'background-color: #EFEFEF99'
        }
      } else {
        if (tweetIndex % 2 === 0) {
          return 'background-color: #EFEFEF99'
        } else {
          return 'background-color: #FFFFFF99'
        }
      }
    },
    getMoreTweets: function (index, totalTweets) {
      if (this.tweets.length !== totalTweets) {
        this.getTweets(index, true)
      }
    },
    filterByUser: function (screenName) {
      this.setCustomFilters({screenName: screenName})
      this.$router.push({ path: '/tweets', query: this.$route.query })
    },
    getIndex: function (index) {
      return ((Number(this.page) - 1) * 30) + Number(index) + 1
    },
    alternateImg: function (index) {
      this.users[index]._profile_image_url_https = 'https://abs.twimg.com/sticky/default_profile_images/default_profile.png'
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    getTweets: function (index, increment) {
      var timeout = 0
      if (!increment) {
        this.users.forEach(function (item, idx) { if (idx !== index) item._active = false })
        timeout = 500
      }
      var self = this
      setTimeout(function () {
        var tweetPageNumber = 1
        if (!increment) {
          self.tweets = []
          self.users[index]._active = !self.users[index]._active
        } else {
          tweetPageNumber = (self.tweets.length / 5) + 1
        }
        if (self.users[index]._active) {
          self.dataTweetsState = 'loading'
          axios.all([
            self.$store.dispatch('getTweets', self.getQuery({sortBy: self.options.sortBy === '_tweet_count' || self.options.sortBy === '_followers_count' ? '_user_followers_count' : self.options.sortBy, order: self.options.orderBy, userId: self.users[index]._twitter_id, pageSize: 5, pageNumber: tweetPageNumber}))
          ]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              if (response.data.payload.length > 0) {
                if (increment) {
                  response.data.payload.forEach(function (item) {
                    self.tweets.push(item)
                  })
                } else {
                  self.tweets = response.data.payload
                }
                self.dataTweetsState = 'ready'
              } else {
                self.dataTweetsState = 'noData'
              }
            } else {
              self.dataTweetsState = 'error'
              self.notify({message: 'Something went wrong while fetching data.', show: true})
            }
          })).catch((err) => {
            self.dataTweetsState = 'error'
            self.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      }, timeout, index)
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTwitterUsersWithQtsandRts', this.getQuery({ sortBy: this.options.sortBy, order: this.options.orderBy, pageSize: 30, pageNumber: this.page }))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          r1.data.payload.forEach(function (item) { item._active = false })
          this.users = r1.data.payload
          if (r1.data.payload.length > 0) {
            if (this.topUser < r1.data.payload[0][this.options.sortBy] || this.topUser < r1.data.payload[r1.data.payload.length - 1][this.options.sortBy]) {
              if (r1.data.payload[0][this.options.sortBy] > r1.data.payload[r1.data.payload.length - 1][this.options.sortBy]) {
                this.topUser = r1.data.payload[0][this.options.sortBy]
              } else {
                this.topUser = r1.data.payload[r1.data.payload.length - 1][this.options.sortBy]
              }
            }
            this.dataState = 'ready'
            this.lastPage = (r1.data.payload.length < 30)
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.lastPage = true
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.topUser = 0
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.topUser = 0
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/UsersListing.vue